export const TAIL_TYPE = {
  LINE: 'line',
  ARROW: 'arrow'
}

export const NODE_TYPE = {
  AVAILABLE: 'available',
  PROCESSING: 'processing',
  PENDING: 'pending'
}
